import { Modal, Button } from "react-bootstrap";
import UserManagerSingleton from "../Services/Auth/UserManagerSingleton";

interface ISessionExpirationModalProps {
    showModal : boolean;
    setShowSessionExpirationWarning: Function;
}

export default function SessionExpirationModal(props : ISessionExpirationModalProps) {

    const onPrimaryActionTaken = () => {
        try {
            props.setShowSessionExpirationWarning(false);
            UserManagerSingleton.getInstance().getOidcUserManager().signinSilent().catch((err) => {
                console.error(err);
            });   
        }
        catch (err){
            console.error(err); //possible iframe window responsible for silent token renew timed out, probably should upgrade oidc-client (deprecated) to oidc-client-ts
        }
    }

    return (<>
        {props.showModal && <Modal show={props.showModal} className="session-expiration-warning" backdrop="static" size="lg" aria-labelledby="contained-modal-title-vcenter" centered keyboard={false}>
            <Modal.Header>
                <Modal.Title>Session is about to expire</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>You will be logged out within the next minute due to inactivity. Please click Continue to remain logged into the portal.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="pp-primary" onClick={onPrimaryActionTaken}>Continue</Button>
            </Modal.Footer>
        </Modal>}
        </>);
}